<!-- =========================================================================================
  File Name: PriceList.vue
  Description: Price list Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Lista de precios no encontrada" :active.sync="id_not_found">
      <span>Datos de lista de precios con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'price_lists'}" class="text-inherit underline"> todas las listas de precios</router-link>
      </span>
    </vs-alert>

    <vx-card class="mb-2">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <div class="w-full">
              <div class="w-full flex mb-2">
                <div class="w-1/4 mr-4">
                  <ejs-textbox floatLabelType="Auto" placeholder="Código" :enabled="editing" v-model="data_local.code"/>
                </div>
                <div class="w-3/4">
                  <ejs-textbox floatLabelType="Auto" placeholder="Descripción" :enabled="editing" v-model="data_local.name"/>
                </div>
              </div>
              <div class="w-full flex">
                <div class="w/1-3 mr-4" style="width: 520px;">
                  <ejs-daterangepicker floatLabelType="Auto" placeholder="Período de validez" ref="period" :startDate="initialDate" :endDate="finalDate" :enabled="editing"/>
                </div>
                <div class="w-2/3">
                  <ejs-dropdownlist floatLabelType="Auto" placeholder="Estado" highlight=true :dataSource="status" :fields="{text: 'value', value: 'code'}" v-model="data_local.statusId" :enabled="editing"></ejs-dropdownlist>
                </div>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :multiline="true" :enabled="editing"/>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card>
      <ejs-grid
        ref="grid"
        :dataSource="data_local.products"
        locale='es-GT'
        :toolbar='toolbarOptions'
        :allowPaging="true"
        :pageSettings='pageSettings'
        :allowSorting='true'
        :sortSettings='sortOptions'
        :allowExcelExport='true'
        :toolbarClick='toolbarClick'
        :editSettings='{ allowEditing: true, allowAdding: false, allowDeleting: false, mode: "Batch" }'
      >
        <e-columns>
          <e-column field="id" :visible=false headerText="ID" :isPrimaryKey="true"/>
          <e-column field='code' headerText='Código' width="200" :allowEditing='false'/>
          <e-column field="name" headerText="Descripción" :allowEditing='false'/>
          <e-column field="price" headerText="Precio" textAlign='Right' format="N2" editType='numericedit' :edit='numericParams' width="150"/>
        </e-columns>
      </ejs-grid>
<!--      <div class="w-full">-->
<!--        <h1>hola</h1>-->
<!--      </div>-->
    </vx-card>
  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js')

  import Vue from "vue";
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DateRangePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {GridPlugin, Toolbar, Search, Page, Sort, ExcelExport, Edit} from '@syncfusion/ej2-vue-grids';

  Vue.use(TextBoxPlugin);
  Vue.use(DateRangePickerPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(GridPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);
  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'daterangepicker': {
        placeholder: 'Seleccione período',
        startLabel: 'Fecha inicial',
        endLabel: 'Fecha final',
        applyText: 'Seleccionar',
        cancelText: 'Cancelar',
        selectedDays: 'Seleccione día inicial y final',
        days: 'Días'
      },
      'grid': {
        'EmptyRecord': 'No se encontraron productos en lista de precios',
        'Search': 'Buscar',
        'Excelexport': 'Exportar',
        'Edit': 'Editar',
        'Update': 'Guardar',
        'Cancel': 'Cancelar',
        'OKButton': 'Aceptar',
        'CancelButton': 'Cancelar',
        'BatchSaveConfirm': '¿Está seguro de guardar los cambios efectuados?',
        'BatchSaveLostChanges	': 'Los cambios efectuados se perderán. ¿Está seguro de cancelar?',
      },
      'pager': {
        'currentPageInfo': '{0} de {1} páginas',
        'firstPageTooltip': 'Ir a primera página',
        'lastPageTooltip': 'Ir a última página',
        'nextPageTooltip': 'Ir a página siguiente',
        'previousPageTooltip': 'Ir a página anterior'
      }
    }
  });

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        data: null,
        status: [],
        data_local: {
          id: 0,
          code: '',
          name: '',
          initialDate: null,
          finalDate: null,
          comments: '',
          statusId: 'IN',
          statusName: '',
          products: []
        },
        pageSettings: {pageSize: 10},
        toolbarOptions: ['Search', 'ExcelExport', 'Update', 'Cancel'],
        sortOptions: {columns: [{field: 'name', direction: 'Ascending'}, {field: 'code', direction: 'Ascending'}]},
        initialDate: null,
        finalDate: null,
        id_not_found: false,
        numericParams: {
          params: {
            validateDecimalOnType: true,
            decimals: 2,
            format: "N"
          }
        },
      }
    },
    provide: {
      grid: [Toolbar, Search, Page, Sort, ExcelExport, Edit]
    },
    methods: {
      reset_data() {
        if (this.$route.params.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'price_lists'});
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            this.$http.post(deltaPOS_config.default.apiURL + '/sale/price_lists/data', {id: id, context: this.$store.state.AppActiveUser}).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
                self.initialDate = new Date(self.data_local.initialDate.slice(0, -1));
                self.finalDate = new Date(self.data_local.finalDate.slice(0, -1));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      dateISOFormat(value) {
        const d = new Date(value.getTime() - (6 * 60 * 60 * 1000));
        return d.toISOString();
      },
      validateForm() {
        var message = '';
        if (this.data_local.code.trim() == '') {
          message = 'Debe indicar un código';
        } else if (this.data_local.name.trim() == '') {
          message = 'Debe indicar una descripción';
        }
        this.initialDate = this.$refs.period.getSelectedRange().startDate;
        this.finalDate = this.$refs.period.getSelectedRange().endDate;
        if (this.initialDate) {
          if (this.finalDate) {
            this.initialDate.setHours(0);
            this.initialDate.setMinutes(0);
            this.initialDate.setSeconds(0);
            this.finalDate.setHours(23);
            this.finalDate.setMinutes(59);
            this.finalDate.setSeconds(59);
            this.data_local.initialDate = this.dateISOFormat(this.initialDate);
            this.data_local.finalDate = this.dateISOFormat(this.finalDate);
            if (this.finalDate < this.initialDate) {
              message = 'Fecha final debe ser mayor a fecha inicial'
            }
          } else {
            message = 'Fecha final incorrecta';
          }
        } else {
          message = 'Fecha inicial incorrecta';
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error validando información',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de lista de precios',
            type: 'point'
          });
          var self = this;
          this.data_local.id = this.id;
          this.data_local.context = this.$store.state.AppActiveUser;
          this.data_local.createdBy = parseInt(localStorage.getItem(`${deltaPOS_config.default.itemPrefix}UserId`));
          this.$http.post(deltaPOS_config.default.apiURL + '/sale/price_lists/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de la lista de precios fueron actualizados correctamente',
                color: 'primary'
              });
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.editing = false;
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar lista de precios "${this.data.name}"`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        this.$vs.loading({
          text: 'Eliminando lista de precios',
          type: 'point'
        });
        var self = this;
        this.$http.post(deltaPOS_config.default.apiURL + '/sale/price_lists/delete', {id: this.id, context: this.$store.state.AppActiveUser}).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información eliminada',
              text: 'Datos de la lista de precios fueron eliminados correctamente',
              color: 'primary'
            });
            self.$router.push({name: 'price_lists'});
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          this.editing = false;
          this.$vs.loading.close();
        });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      if (this.id > 0) {
        this.$vs.loading({
          text: 'Cargando datos de lista de precios',
          type: 'point'
        });
      }
      var self = this;
      this.$http
        .post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'ESTADOLISTAPRECIOS'})
        .then(response => {
          if (response.data.success) {
            self.status = response.data.data;
          }
          self.getData(self.id);
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  @import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
